import { StyleSheet, Platform } from 'react-native';

export const styles = StyleSheet.create({
    container: {
        width: '100%',
        elevation: 4,
        shadowColor: '#000',
        shadowOpacity: 0.05,
        shadowRadius: 2,
        shadowOffset: { width: 0, height: 2 },
        // 修复：移除固定高度，由内容+paddingTop自适应
        // 避免固定高度导致的间距叠加
    },
    navRow: {
        flexDirection: 'row',
        alignItems: 'center',
        height: 44, // 导航栏内容高度（固定）
        justifyContent: 'space-between',
        paddingHorizontal: 8,
        // 修复：Android 端减少底部内边距，避免整体过高
        ...(Platform.OS === 'android' ? { paddingBottom: 2 } : {}),
    },
    iconArea: {
        width: 40,
        height: 44,
        justifyContent: 'center',
        alignItems: 'center',
        // 修复：避免点击区域过大导致的视觉间距
        overflow: 'hidden',
    },
    title: {
        flex: 1,
        textAlign: 'center',
        fontSize: 18,
        fontWeight: 'bold',
        // 修复：默认文字颜色适配白色背景
        color: '#333',
    },
});